import React from "react";
import { getDisplayName } from "utils/functions";
import { ApplicationFeaturesContext } from "./ApplicationFeaturesContext";

export function withApplicationFeatures(Component) {
  let comp = function ApplicationFeaturesComponent(props) {
    return (
      <ApplicationFeaturesContext.Consumer>
        {applicationFeatures => <Component {...props} applicationFeatures={applicationFeatures} />}
      </ApplicationFeaturesContext.Consumer>
    );
  };
  comp.displayName = `withApplicationFeatures(${getDisplayName(Component)})`;
  return comp;
}
